import { render } from "./FirstPageAfterPushOffer.vue?vue&type=template&id=2593cba6&scoped=true&ts=true"
import script from "./FirstPageAfterPushOffer.ts?vue&type=script&lang=ts"
export * from "./FirstPageAfterPushOffer.ts?vue&type=script&lang=ts"

import "./FirstPageAfterPushOffer.vue?vue&type=style&index=0&id=2593cba6&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetal\\cmportal-frontend-master\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2593cba6"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
